import AiChat from "@/pages/AiChat";
import { useAuth } from "@/lib/AuthContext";
import { useNavigate } from "react-router-dom";
import AppShell from "@/components/AppShell";
import { Crown } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ProAI() {
  const { user } = useAuth();
  const nav = useNavigate();
  if (!user) return null;
  if (!user.subscription_active) {
    return (
      <AppShell role="pro" title="IA Pro (Premium)">
        <div className="bg-pro text-white rounded-2xl p-6 mt-6 text-center">
          <div className="h-14 w-14 mx-auto rounded-2xl bg-white/10 flex items-center justify-center mb-3">
            <Crown className="w-7 h-7 text-brand" />
          </div>
          <h2 className="font-heading font-bold text-xl">IA Pro réservée aux Premium</h2>
          <p className="text-sm text-white/80 mt-2 leading-relaxed">
            Obtenez des conseils sur-mesure pour booster votre profil, augmenter vos conversions
            et signer plus de chantiers locaux.
          </p>
          <Button onClick={() => nav("/pro/profile")} className="mt-4 rounded-full bg-brand hover:bg-brand-hover" data-testid="goto-subscribe-btn">
            S'abonner 9,99€/mois
          </Button>
        </div>
      </AppShell>
    );
  }
  return <AiChat role="pro" title="IA Pro" suggestions={[
    "Comment améliorer ma fiche pour décrocher plus de chantiers ?",
    "Quel discours adopter pour répondre à un lead urgent ?",
    "Donne-moi 3 conseils SEO local pour mon activité",
  ]} />;
}
